import { ArrowRight, AlertTriangle, CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/landing/primitives";
import { PROBLEMS } from "@/data/content";

export default function ProblemsSolutions() {
  return (
    <section id="solutions" className="relative py-20 md:py-28 scroll-mt-24" data-testid="section-solutions">
      <div className="container-trt">
        <SectionHeading
          eyebrow="Why TRT"
          title="Legacy asset problems,"
          highlight="solved on-chain"
          sub="Traditional asset ownership is slow, illiquid and opaque. TRT rebuilds it as a transparent, liquid and intelligent asset class."
        />

        <div className="mt-16 grid md:grid-cols-2 gap-5">
          {PROBLEMS.map((row, i) => (
            <Reveal key={i} delay={(i % 2) * 0.08}>
              <div className="glass rounded-2xl p-5 card-hover flex items-stretch gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-wide text-red-400/80 mb-2">
                    <AlertTriangle className="w-3.5 h-3.5" /> Problem
                  </div>
                  <p className="text-sm text-[var(--muted)] leading-snug">{row.p}</p>
                </div>
                <div className="flex items-center">
                  <ArrowRight className="w-5 h-5 text-[var(--gold-3)]" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-wide text-[var(--emerald)] mb-2">
                    <CheckCircle2 className="w-3.5 h-3.5" /> TRT Solution
                  </div>
                  <p className="text-sm text-[var(--text)] leading-snug font-medium">{row.s}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
